module.exports = __webpack_public_path__ + "static/media/White-Primary.2d9f1d35.svg";